/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createExp } from '../../factoriesAny.js';
export var expDependencies = {
  typedDependencies,
  createExp
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesExp.generated.js
// module id = null
// module chunks = 